import "./vendor.js";

// Core functionality (loaded on every page)
import "./custom/anchor-links.js";
import "./custom/cta-bar.js";
import "./custom/deferred-block-loader.js";
import "./custom/lazy-load.js";
import "./custom/mirrored-search.js";
import "./custom/navigation.js";
import "./custom/navigation-mobile.js";
import "./custom/rellax.js";
import "./custom/scrollFade.js";
import "./custom/search-bar.js";
import "./custom/share-links.js";
import "./custom/tabs.js";
import "./custom/append-utm-data.js";

// Case study "Show more" — keep static. Dynamic import() was unreliable once
// main.js is served from dist/scripts/ (Parcel chunk registry / path mismatch).
import "./custom/casestudy-details.js";

// Only include truly core blocks that appear on most pages
import "./blocks/block-downloads.js";
import "./blocks/contact-select-block.js";
import "./blocks/copy-cta-list.js";

// footer-form.js and nominate-form-2025.js loaded conditionally when form blocks present (see DOMContentLoaded below)

import CookieDeleter from "./utils/CookieDeleter.js";

// Initialize the cookie deleter
new CookieDeleter();

// Conditional script loading based on page type
document.addEventListener('DOMContentLoaded', function() {
    // Load other conditional scripts as needed
    if (document.querySelector('.qanda')) {
        import('./custom/qanda.js');
    }

    if (document.querySelector('.multi-filter')) {
        import('./custom/multi-filter.js');
    }

    if (document.querySelector('.filter-select')) {
        import('./custom/filter-select.js');
    }

    // Load search dropdown filtering script on search pages
    if (document.querySelector('.filter-search') || document.querySelector('#filter-select-search')) {
        import('./custom/filter-select-search.js');
    }

    if (document.querySelector('.team-hub-filter')) {
        import('./custom/team-hub-filter.js');
    }

    if (document.querySelector('.video-block')) {
        import('./custom/video-block.js');
    }

    // Load D365 attribution tracking if forms are present
    if (document.querySelector('.embed_form, .expandable_form__form, .block-inline-embed-form')) {
        import('./custom/d365-attribution-bridge.js').then(() => {
            import('./custom/d365-gtm-integration.js');
        });
        // Load expandable form toggles and nomination form helpers only on form pages
        import('./custom/footer-form.js');
        import('./blocks/nominate-form-2025.js');
    }
});

// Fallback: Retry D365 form detection after a delay (forms may load dynamically)
setTimeout(function() {
    if (document.querySelector('.embed_form, .expandable_form__form, .block-inline-embed-form')) {
        // Check if already loaded
        if (typeof window.D365AttributionBridge === 'undefined') {
            import('./custom/d365-attribution-bridge.js').then(() => {
                if (typeof window.d365AttributionBridge === 'undefined') {
                    import('./custom/d365-gtm-integration.js');
                }
            });
        }
        // Late-load form scripts if form containers appear (e.g. dynamic content)
        import('./custom/footer-form.js');
        import('./blocks/nominate-form-2025.js');
    }
}, 1000);
